import React from 'react'
import HeaderFour from '../header/HeaderFour';
import BannerFive from '../elements/BannerFive';
import AboutOne from '../elements/AboutOne';
import ServiceFIve from '../elements/ServiceFIve';
import WorkingProcess from '../elements/WorkingProcess';
import Blog from '../elements/Blog';
import Footer from '../elements/Footer';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';
import sal from 'sal.js';


function HomeFive() {
    React.useEffect(() => {
        sal({
          threshold: 1,
          once: true,
        });
    }, []);
  return (
    <div>
        
        <div className="index-Five">
            <HeaderFour/>
            <main>
              <BannerFive/>
              <AboutOne/>
              <ServiceFIve/>
              {/* rmp portfolio mesonary area */}
              <div className="tmp-portfolio-area">
                  <div className="container">
                      <div className='row'>
                          <div className="col-lg-12">
                              <div className="section-head">
                                  <div className="section-sub-title center-title">
                                  <img
                                      src="assets/images/services/section-custom-menubar.png "
                                      alt="Business_Consulting_services"
                                  />
                                  <span>OUR PORTFOLIO</span>
                                  </div>
                                  <h2 className="title split-collab">Let's Check Our Best Works</h2>
                              </div>
                          </div>
                      </div>
                      <div className='row'>
                          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                              <Row>
                                  <Col sm={12}>
                                      <Nav variant="pills" className="flex-column tmp-mesonary-area-main main-isotop">
                                          <Nav.Item className='tmp-button-group mb--50 filters-button-group'>
                                              <Nav.Link className='button' eventKey="first"> All Product</Nav.Link>
                                          </Nav.Item>

                                          <Nav.Item className='tmp-button-group mb--50 filters-button-group'>
                                              <Nav.Link className='button' eventKey="second">Dashboard</Nav.Link>
                                          </Nav.Item>

                                          <Nav.Item className='tmp-button-group mb--50 filters-button-group'>
                                              <Nav.Link className='button' eventKey="third">Website</Nav.Link>
                                          </Nav.Item>

                                          <Nav.Item className='tmp-button-group mb--50 filters-button-group'>
                                              <Nav.Link className='button' eventKey="four">HTML/CSS</Nav.Link>
                                          </Nav.Item>
                                      </Nav>
                                  </Col>
                                  <Col sm={12}>
                                  <Tab.Content>

                                      <Tab.Pane eventKey="first">
                                          
                                          <div className='row g-5'>
                                              <div
                                                  className="flash grid-item-p element-item transition creative col-lg-4 col-md-6 col-sm-6">
                                                  {/* single portfolio-item */}
                                                  <div className="tmp-single-portfolio-item">
                                                      <Link to={'/ProjectDetails'} className="thumbnail">
                                                      <img
                                                          src="assets/images/product/07.jpg"
                                                          alt="personal_portfolio"
                                                      />
                                                      </Link>
                                                      <div className="tmp-inner-content">
                                                      <div className="top-item">
                                                          <span className="left">Mobile App Design</span>
                                                          <span className="left">25 likes</span>
                                                      </div>
                                                      <Link to={'/ProjectDetails'}>
                                                          <h2 className="title">Its Our Igniting Innovation Construction</h2>
                                                      </Link>
                                                      </div>
                                                  </div>
                                                  {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition design col-lg-4 col-md-6 col-sm-6"
                                              data-category="transition"
                                              >
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/02.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">Showcasing Startup Ventures</h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition photo col-lg-4 col-md-6 col-sm-6"
                                              data-category="transition"
                                              >
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/03.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">Navigating Startup Success Consulting Business</h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition photo style col-lg-4 col-md-6 col-sm-6">
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/04.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">
                                                      Modern Mobile App Design UI/UX <br />
                                                      In Figma
                                                      </h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition creative col-lg-4 col-md-6 col-sm-6">
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/05.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">
                                                      Mobile App Design UI/UX <br />
                                                      In Figma Design
                                                      </h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition photo style design col-lg-4 col-md-6 col-sm-6">
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/06.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">
                                                      Mobile App Design UI/UX <br />
                                                      In Figma
                                                      </h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                          </div>

                                      </Tab.Pane>
                                      
                                      <Tab.Pane eventKey="second">

                                          <div className='row g-5'>
                                              <div
                                              className="flash grid-item-p element-item transition creative col-lg-4 col-md-6 col-sm-6">
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/05.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">
                                                      Mobile App Design UI/UX <br />
                                                      In Figma
                                                      </h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition photo style design col-lg-4 col-md-6 col-sm-6">
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/06.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">
                                                      Mobile App Design UI/UX <br />
                                                      In Figma
                                                      </h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                          </div>

                                      </Tab.Pane>

                                      <Tab.Pane eventKey="third">

                                          <div className='row g-5'>

                                              <div
                                              className="flash grid-item-p element-item transition photo col-lg-4 col-md-6 col-sm-6"
                                              data-category="transition"
                                              >
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/03.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">Navigating Startup Success</h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition photo style col-lg-4 col-md-6 col-sm-6">
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/04.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">
                                                      Mobile App Design UI/UX <br />
                                                      In Figma
                                                      </h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition creative col-lg-4 col-md-6 col-sm-6">
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/05.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">
                                                      Mobile App Design UI/UX <br />
                                                      In Figma
                                                      </h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition photo style design col-lg-4 col-md-6 col-sm-6">
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/06.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">
                                                      Mobile App Design UI/UX <br />
                                                      In Figma
                                                      </h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                          </div>

                                      </Tab.Pane>

                                      <Tab.Pane eventKey="four">

                                          <div className='row g-5'>
                                              <div
                                                  className="flash grid-item-p element-item transition creative col-lg-4 col-md-6 col-sm-6">
                                                  {/* single portfolio-item */}
                                                  <div className="tmp-single-portfolio-item">
                                                      <Link to={'/ProjectDetails'} className="thumbnail">
                                                      <img
                                                          src="assets/images/product/07.jpg"
                                                          alt="personal_portfolio"
                                                      />
                                                      </Link>
                                                      <div className="tmp-inner-content">
                                                      <div className="top-item">
                                                          <span className="left">Mobile App Design</span>
                                                          <span className="left">25 likes</span>
                                                      </div>
                                                      <Link to={'/ProjectDetails'}>
                                                          <h2 className="title">Its Our Igniting Innovation</h2>
                                                      </Link>
                                                      </div>
                                                  </div>
                                                  {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition design col-lg-4 col-md-6 col-sm-6"
                                              data-category="transition"
                                              >
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/02.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">Showcasing Startup Ventures</h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition photo col-lg-4 col-md-6 col-sm-6"
                                              data-category="transition"
                                              >
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/03.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">Navigating Startup Success</h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition photo style col-lg-4 col-md-6 col-sm-6">
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/04.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">
                                                      Mobile App Design UI/UX <br />
                                                      In Figma
                                                      </h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition creative col-lg-4 col-md-6 col-sm-6">
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/05.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">
                                                      Mobile App Design UI/UX <br />
                                                      In Figma
                                                      </h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                              <div
                                              className="flash grid-item-p element-item transition photo style design col-lg-4 col-md-6 col-sm-6">
                                              {/* single portfolio-item */}
                                              <div className="tmp-single-portfolio-item">
                                                  <Link to={'/ProjectDetails'} className="thumbnail">
                                                  <img
                                                      src="assets/images/product/06.jpg"
                                                      alt="personal_portfolio"
                                                  />
                                                  </Link>
                                                  <div className="tmp-inner-content">
                                                  <div className="top-item">
                                                      <span className="left">Mobile App Design</span>
                                                      <span className="left">25 likes</span>
                                                  </div>
                                                  <Link to={'/ProjectDetails'}>
                                                      <h2 className="title">
                                                      Mobile App Design UI/UX <br />
                                                      In Figma
                                                      </h2>
                                                  </Link>
                                                  </div>
                                              </div>
                                              {/* single portfolio-item end */}
                                              </div>
                                          </div>

                                      </Tab.Pane>

                                  </Tab.Content>
                                  </Col>
                              </Row>
                          </Tab.Container>
                      </div>
                  </div>
              </div>
              {/* rmp portfolio mesonary area end */}
              <WorkingProcess/>
              {/* Tmp Blog Area Start  */}
              <div className="tmp-blog-area tmp-section-gapBottom">
                  <div className="container">
                  <div className="row">
                      <div className="col-lg-12">
                      <div className="section-head">
                          <div className="section-sub-title center-title">
                          <img
                              src="assets/images/services/section-custom-menubar.png "
                              alt="Corporate_service"
                          />
                          <span className="subtitle">LATEST BLOG</span>
                          </div>
                          <h2 className="title split-collab">Latest News &amp; Articles</h2>
                      </div>
                      </div>
                  </div>
                  <div className="row g-5">
                      <div
                      className="col-lg-4 col-md-6 col-sm-12 col1-2 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".1s">
                      <div className="single-blog">
                          <div className="blog-inner">
                          <div className="thumbnail">
                              <Link to={'/BlogDetails'}>
                              <img
                                  src="assets/images/blog/blog-2.png"
                                  alt="Business Consulting Blog"
                              />
                              </Link>
                              <div className="pmt-blog-meta">
                              <ul className="all-meta">
                                  <li className="date">
                                  <span>20</span>
                                  </li>
                                  <li className="month">
                                  <span>JAN</span>
                                  </li>
                              </ul>
                              </div>
                          </div>
                          <div className="blog-content">
                              <div className="blog-head">
                              <span className="name">Sultan Ahmed</span>
                              <span className="designation">Consulting</span>
                              </div>
                              <div className="blog-body">
                              <Link to={'/BlogDetails'} className="title-area">
                                  <h4 className="title">
                                  Consulted admitting wooded is power acuteness.
                                  </h4>
                              </Link>
                              <p className="description">
                                  There are many variations of passages of Lorem Ipsum
                                  available, but the majority have suffered.
                              </p>
                              </div>
                              <Link className="btn-read-more" to={'/BlogDetails'}>
                              <span className="read-more-text">Read More</span>
                              <span className="read-more-icon">
                                  <i className="fa-solid fa-arrow-right" />
                              </span>
                              </Link>
                          </div>
                          </div>
                      </div>
                      </div>
                      <div
                      className="col-lg-4 col-md-6 col-sm-12 col1-2 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".3s">
                      <div className="single-blog">
                          <div className="blog-inner">
                          <div className="thumbnail">
                              <Link to={'/BlogDetails'}>
                              <img
                                  src="assets/images/blog/blog-3.png"
                                  alt="Business Consulting Blog"
                              />
                              </Link>
                              <div className="pmt-blog-meta">
                              <ul className="all-meta">
                                  <li className="date">
                                  <span>20</span>
                                  </li>
                                  <li className="month">
                                  <span>JAN</span>
                                  </li>
                              </ul>
                              </div>
                          </div>
                          <div className="blog-content">
                              <div className="blog-head">
                              <span className="name">Sultan Ahmed</span>
                              <span className="designation">Consulting</span>
                              </div>
                              <div className="blog-body">
                              <Link to={'/BlogDetails'} className="title-area">
                                  <h4 className="title">
                                  Grow your business strategy with business consulting.
                                  </h4>
                              </Link>
                              <p className="description">
                                  There are many variations of passages of Lorem Ipsum
                                  available, but the majority have suffered.
                              </p>
                              </div>
                              <Link className="btn-read-more" to={'/BlogDetails'}>
                              <span className="read-more-text">Read More</span>
                              <span className="read-more-icon">
                                  <i className="fa-solid fa-arrow-right" />
                              </span>
                              </Link>
                          </div>
                          </div>
                      </div>
                      </div>
                      <div
                      className="col-lg-4 col-md-6 col-sm-12 col1-2 wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".5s">
                      <div className="single-blog">
                          <div className="blog-inner">
                          <div className="thumbnail">
                              <Link to={'/BlogDetails'}>
                              <img
                                  src="assets/images/blog/blog-1.png"
                                  alt="Business Consulting Blog"
                              />
                              </Link>
                              <div className="pmt-blog-meta">
                              <ul className="all-meta">
                                  <li className="date">
                                  <span>20</span>
                                  </li>
                                  <li className="month">
                                  <span>JAN</span>
                                  </li>
                              </ul>
                              </div>
                          </div>
                          <div className="blog-content">
                              <div className="blog-head">
                              <span className="name">Sultan Ahmed</span>
                              <span className="designation">Consulting</span>
                              </div>
                              <div className="blog-body">
                              <Link to={'/BlogDetails'} className="title-area">
                                  <h4 className="title">
                                  Facilis dolor eques about under official,presentism.
                                  </h4>
                              </Link>
                              <p className="description">
                                  There are many variations of passages of Lorem Ipsum
                                  available, but the majority have suffered.
                              </p>
                              </div>
                              <Link className="btn-read-more" to={'/BlogDetails'}>
                              <span className="read-more-text">Read More</span>
                              <span className="read-more-icon">
                                  <i className="fa-solid fa-arrow-right" />
                              </span>
                              </Link>
                          </div>
                          </div>
                      </div>
                      </div>
                  </div>
                  </div>
              </div>
              {/* Tmp Blog Area Start  */}
              <Footer/>


            </main>
        </div>



    </div>
  )
}

export default HomeFive